// extracted by mini-css-extract-plugin
export var pillWrapper = "_q1-0";
export var showOverflow = "_q1-1";